import { Theme } from '@mui/material';
import { createSelectors } from '@src/stores/create-selectors';
import {
  BrandPaletteKeys,
  BrandPaletteKeysEnum,
  createBrandTheme,
} from '@src/themes';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type State = {
  partner: BrandPaletteKeys;
  theme: Theme;
  actions: Actions;
};

type Actions = {
  // set current theme
  setTheme: (theme: BrandPaletteKeys) => void;
};

/**
 * Zustand store for the MUI Theme.
 * Defaults to maxmyinterest.com
 */
const useThemeStoreBase = create<State>()(
  devtools(
    (set) => ({
      partner: BrandPaletteKeysEnum.MaxMyInterest,
      theme: createBrandTheme(BrandPaletteKeysEnum.MaxMyInterest),
      actions: {
        setTheme: (key: BrandPaletteKeys) =>
          set(
            { partner: key, theme: createBrandTheme(key) },
            false,
            'setTheme',
          ),
      },
    }),
    { name: 'useThemeState' },
  ),
);

export const useThemeStore = createSelectors(useThemeStoreBase);
